import type { FaireProductEntity } from "../../entity_types/product";

export const p_6hsd69fav8: FaireProductEntity = {
  token: "p_6hsd69fav8",
  type: "product",
  name: "Color the Bible for Girls",
  brandToken: "b_4q06brhpm1",
  brandName: "Harvest House Publishers Gift & Specialty Books",
  imageUrl:
    "https://cdn.faire.com/fastly/68c57abbe7d54b6e4552dcdb3e49f4d81e8a2fac4dac2be3bc1d765126c8ff22.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ccf31ef2933875820607b370dad2571528b3e2d521759a816adb126999554e29.jpeg",
    "https://cdn.faire.com/fastly/1d4929175e6e6261382cd5cb0528418a9d36e5815fdef7ebbf2913874b7554a5.jpeg",
    "https://cdn.faire.com/fastly/c9d5f52da8a8377da7650a439e26c701e68a7376db21f6d40c2ecf3784c4c7a5.jpeg",
    "https://cdn.faire.com/fastly/b636e06ae2277b0b8eadbfbc715440ded69a0f7ee1231f1a24c2816926b841dd.jpeg",
    "https://cdn.faire.com/fastly/b2346162d01a9d8852c61a655c5b82b0273c996577050714593418bc2e7b2f04.jpeg",
  ],
  priceDollars: 7.62,
  description:
    "Buy 6 of any title and get the 7th free!\n\nGirls will have a great time coloring in over 35 inspiring Bible verses with perforated pages perfect for easy tear-out and display.\n \nAre you looking for a fun and fresh way to share biblical wisdom with a special young girl? These playful patterns featuring adorable animals, floral flourishes, and life-shaping Scripture verses from the Old and New Testament are waiting for girls to add their creative and colorful touches to each page. The perforated pages make it easy for girls to tear out and display their instantly frameable works of art wherever they need a reminder of God’s truth.\n \nColor the Bible for Girls is perfect for quiet time, rainy-day activities, parties with friends, mother-daughter connection, memory verse practice, or gift giving.\n",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:47.460Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
